import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../../../elements/Box';
import Link from '../../../../elements/Link';
import { StyledProps } from '@front10';

interface Props {
  /**
   * Translation key
   */
  labelKey: string;
  /**
   * Data test ID of Disclaimer
   */
  dataTestId: string;
  /**
   * url
   */
  urls: $TSFixMe;
  defaultUrl: string;
  siteEdition: string;
  seeMoreLinkSettings: any;
}

function SeeMore(props: StyledProps<Props>) {
  const { labelKey, dataTestId, urls, defaultUrl, siteEdition, seeMoreLinkSettings } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  let url = defaultUrl ?? '';

  if (urls && urls[siteEdition]) {
    url = urls[siteEdition];
  }

  return (
    <Box className={`${className} fr-see-more`} style={style} dataTestId={dataTestId}>
      <Link href={url} {...seeMoreLinkSettings}>
        {translate(labelKey, 'SEE MORE DEALS')}
      </Link>
    </Box>
  );
}

SeeMore.defaultProps = {
  labelKey: 'cmp-see-more',
  dataTestId: 'seeMore',
  urls: {},
  defaultUrl: '',
  siteEdition: 'en',
  seeMoreLinkSettings: {}
};

SeeMore.componentName = 'SeeMore';

export default SeeMore;
